/**
 *
 * Asynchronously loads the component for Homeowners
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
